// utils/slugUtils.js

export const createSlug = (name) => {
    return name.toLowerCase().replace(/ /g, "-");
  };
  
  export const decodeSlug = (slug) => {
    return slug ? slug.replace(/-/g, " ") : ""; // Replace hyphens with spaces
  };
  
  